import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Html5Entities } from 'html-entities/lib/html5-entities';
import { getServiceNotes } from '../common/service-notes';

/**ToDo Documentazione */
@Component({
  selector: 'app-optionals',
  styleUrls: ['./optionals.component.scss'],
  templateUrl: './optionals.component.html'
})
export class OptionalsComponent {
  @Input() public day: any;
  /** Tipologie activity da nascondere (solo tab Activities); assente ⇒ tutto visibile. */
  @Input() public hiddenCategories: string[] = [];
  @Input() public showOptionlServices: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  /** Allowlist tipologie activity da mostrare (tab "Altri servizi"); assente ⇒ tutte. */
  @Input() public visibleCategories: string[] = [];
  public language: string;
  state: any = sessionStorage.getItem('state');

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getActivityImage(category: string): string | undefined {
    if (!category) {
      return undefined;
    }
    return `assets/custom/${this.version}/images/activities/${category}.png`;
  }

  public getActivityIcon(category: string): string | undefined {
    if (!category) {
      return undefined;
    }
    return `assets/custom/${this.version}/icons/activities/${category}.svg`;
  }

  public getFilteredNotes(notes: any): any[] {
    return getServiceNotes(notes, this.state);
  }

  /** Esclude le activity con `category` in blacklist (multi-tenant additivo). */
  public getVisibleOptionals(optionals: any[]): any[] {
    let visible: any[] = optionals || [];

    if (this.visibleCategories?.length) {
      visible = visible.filter(optional => this.visibleCategories.includes(optional?.category));
    }

    if (this.hiddenCategories?.length) {
      visible = visible.filter(optional => !this.hiddenCategories.includes(optional?.category));
    }

    return visible;
  }

  constructor(public translateService: TranslateService) {
    this.language = translateService.currentLang;
  }

  ngOnChanges(changes: any){
    if (changes.noImageUrl) {
      this.noImageUrl = changes.noImageUrl.currentValue;
    }
  }

  public decodeHtml(text: string): string {
    return Html5Entities.decode(text);
  }

  public getSupplementsAndReductions(service: any): any[] {
    const source = service?.supplementsAndReductions
      || service?.items?.[0]?.supplementsAndReductions
      || service?.optionals?.[0]?.supplementsAndReductions
      || [];
    return Array.isArray(source) ? source : [];
  }

  public hasSupplementsAndReductions(service: any): boolean {
    return this.getSupplementsAndReductions(service).length > 0;
  }

  handleImgError(ev: any){
    const source = ev.target as HTMLImageElement;
    const fallback = `assets/custom/${sessionStorage.getItem('version')}/images/logo_tour_operator.png`;
    source.src = this.noImageUrl || fallback;
  }

}
